import React from 'react';

import { Stack, Typography } from '@gogame/components';

export function createBatchAction(source) {
  return async (data) => {
    const values = await Promise.allSettled(data.map((row) => source(row)));

    const errors = [];
    const results = [];

    values.forEach(({ status, value, reason }, i) => {
      if (status === 'fulfilled') {
        results.push(value);
      } else if (status === 'rejected') {
        errors.push(
          <Stack style={{ maxWidth: 700 }} component={'span'}>
            <Typography component={'span'}>
              {data?.[i]?.name} due to:
            </Typography>
            <Typography
              component={'span'}
              style={{
                wordBreak: 'break-all',
              }}
            >
              {reason?.message}
            </Typography>
          </Stack>
        );
      } else {
        /* eslint-disable-next-line */
        console.error(`unknown status - ${status}`);
      }
    });

    const resultData = {
      errors: errors,
      results: results,
      total: values.length,
    };

    if (errors.length) {
      return Promise.reject(resultData);
    } else {
      return resultData;
    }
  };
}
